import {css} from '@emotion/css';
import {Breakpoints, mq} from '@fo/shared/styles/mixins';
import {coloursV2, fonts, spacing} from '@fo/shared/styles/variables';

const styles = {
  container: css`
    label: authorBio__container;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: ${spacing.M} 0 ${spacing.L} 0;
  `,
  profile: (showBorderTop: boolean): string => css`
    label: authorBio__profile;
    display: flex;
    flex-direction: column;
    gap: ${spacing.S};
    width: 100%;
    padding: ${spacing.M} ${spacing.XS} ${spacing.XXXS};
    ${showBorderTop &&
    css`
      border-top: 1px solid ${coloursV2.generic.lightGrey};
    `}
    ${mq(Breakpoints.TABLET)} {
      flex-direction: row;
    }
  `,
  avatar: css`
    label: authorBio__avatar;
    flex: 0 1;
  `,
  editor: css`
    label: authorBio__editor;
    display: flex;
    flex: 1 0;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    ${mq(Breakpoints.TABLET)} {
      text-align: left;
    }
  `,
  title: css`
    label: authorBio__title;
    display: inline;
    margin: 0 auto ${spacing.XXS} 0;
    color: ${coloursV2.font.black};
    font-size: ${fonts.size.H2};
    font-weight: ${fonts.weight.SEMI_BOLD};
    line-height: 1.1;
    padding-top: ${spacing.XXXS};
    text-align: center;
    ${mq(Breakpoints.TABLET)} {
      text-align: left;
    }
  `,
  role: css`
    label: authorBio__role;
    margin: 0 0 ${spacing.XXS};
    font-size: ${fonts.size.XXL};
    font-weight: ${fonts.weight.SEMI_BOLD};
  `,
  shortBio: css`
    label: authorBio__shortBio;
    font-size: ${fonts.size.L};
    text-align: left;
  `,
  column: css`
    label: authorBio__column;
    display: flex;
    justify-content: center;
  `,
  link: css`
    label: authorBio__link;
    margin-bottom: ${spacing.XXS};
    display: inline;
    width: auto;
    text-decoration: none;
    &:link,
    &:visited,
    &:active {
      & > div {
        color: ${coloursV2.font.black};
        text-decoration: underline;
      }
    }
    &:hover {
      & > div {
        color: ${coloursV2.brand.secondary};
        text-decoration: none;
      }
    }
    ${mq(Breakpoints.TABLET)} {
      margin: 0 0 ${spacing.XXXS};
    }
  `,
};

export default styles;
